import { render, staticRenderFns } from "./ServiceTypes.vue?vue&type=template&id=424d095f"
import script from "./ServiceTypes.vue?vue&type=script&lang=js"
export * from "./ServiceTypes.vue?vue&type=script&lang=js"
import style0 from "./ServiceTypes.vue?vue&type=style&index=0&id=424d095f&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports